export const version = 'kunde-v1.20.0-SNAPSHOT-f87a5af5fad6e50e8be26f8f973d690a1a579bd5';